import React from 'react';

import style from '../TradeInNewCalculator.module.pcss';

export const SelectWrapper: React.FC = ({ children }) => <div className={style.dropdown}>{children}</div>;
